"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpMockApiInterceptor = void 0;
var core_1 = require("@angular/core");
var mock_bmw_config_1 = require("./mock.bmw.config");
var currentMockEndpoint;
var HttpMockApiInterceptor = /** @class */ (function () {
    function HttpMockApiInterceptor() {
    }
    HttpMockApiInterceptor.prototype.intercept = function (request, next) {
        currentMockEndpoint = mock_bmw_config_1.default[request.method] && mock_bmw_config_1.default[request.method][request.url] || null;
        return currentMockEndpoint ? currentMockEndpoint.handler() : next.handle(request);
    };
    HttpMockApiInterceptor = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], HttpMockApiInterceptor);
    return HttpMockApiInterceptor;
}());
exports.HttpMockApiInterceptor = HttpMockApiInterceptor;
